import React, { useState, useEffect } from 'react';
import { useToast } from '../../../components/Toast';
import './Forms.css';

export default function CareersForm({ apiBase, activeTab }) {
  const toast = useToast();
  const sectionMap = {
    'cms-car-hero': { title: 'Hero Section', section: 'hero' },
    'cms-car-openings': { title: 'Job Openings', section: 'openings' },
    'cms-car-culture': { title: 'Our Culture', section: 'culture' }
  };

  const sectionConfig = sectionMap[activeTab] || sectionMap['cms-car-hero'];
  const [content, setContent] = useState({});
  const [isDirty, setIsDirty] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [loading, setLoading] = useState(true);
  const [sectionId, setSectionId] = useState(null);

  useEffect(() => { loadSection(); }, [activeTab]); // eslint-disable-line react-hooks/exhaustive-deps

  const loadSection = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${apiBase}/content?menu=careers`, { credentials: 'include' });
      const result = await response.json();
      if (result.ok && Array.isArray(result.data)) {
        const found = result.data.find(s => s.section === sectionConfig.section);
        if (found) {
          setSectionId(found.id);
          setContent(found.content || { en: {}, id: {} });
        }
      }
    } catch (err) {
      toast.error('Failed to load');
    } finally {
      setLoading(false);
    }
  };

  const updateField = (lang, fieldKey, value) => {
    setContent(prev => ({ ...prev, [lang]: { ...prev[lang], [fieldKey]: value } }));
    setIsDirty(true);
  };

  const saveSection = async () => {
    if (!sectionId) return;
    setIsSaving(true);
    try {
      await fetch(`${apiBase}/content/${sectionId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ content })
      });
      toast.success(`✓ Saved`);
      setIsDirty(false);
    } catch (err) {
      toast.error('Save failed');
    } finally {
      setIsSaving(false);
    }
  };

  if (loading) return <div className="cms-loading"><div>Loading...</div></div>;
  const en = content.en || {};

  return (
    <div className="cms-form">
      <toast.ToastContainer />
      <h2>{sectionConfig.title}</h2>

      {activeTab === 'cms-car-hero' && (
        <div>
          <div className="form-group"><label>Title</label><input type="text" value={en.title || ''} onChange={(e) => updateField('en', 'title', e.target.value)} maxLength={200} /></div>
          <div className="form-group"><label>Subtitle</label><textarea value={en.subtitle || ''} onChange={(e) => updateField('en', 'subtitle', e.target.value)} rows="2" /></div>
        </div>
      )}

      {activeTab === 'cms-car-openings' && (
        <div>
          <div className="form-group"><label>Job Openings Overview</label><textarea value={en.overview || ''} onChange={(e) => updateField('en', 'overview', e.target.value)} rows="4" /></div>
          <h4>Active Job Openings</h4>
          {(en.items || []).map((item, idx) => (
            <div key={idx} style={{ border: '1px solid #ddd', padding: '10px', marginBottom: '10px', borderRadius: '4px' }}>
              <input type="text" value={item?.position || ''} onChange={(e) => { const newItems = [...(en.items || [])]; newItems[idx] = { ...newItems[idx], position: e.target.value }; updateField('en', 'items', newItems); }} placeholder="Job position" maxLength={100} />
              <input type="text" value={item?.department || ''} onChange={(e) => { const newItems = [...(en.items || [])]; newItems[idx] = { ...newItems[idx], department: e.target.value }; updateField('en', 'items', newItems); }} placeholder="Department" maxLength={100} style={{ marginTop: '5px' }} />
              <textarea value={item?.description || ''} onChange={(e) => { const newItems = [...(en.items || [])]; newItems[idx] = { ...newItems[idx], description: e.target.value }; updateField('en', 'items', newItems); }} placeholder="Job description" rows="3" style={{ marginTop: '5px' }} />
              <button type="button" onClick={() => { const newItems = (en.items || []).filter((_, i) => i !== idx); updateField('en', 'items', newItems); }} style={{ background: '#ff6b6b', color: 'white', padding: '5px 10px', border: 'none', borderRadius: '3px', cursor: 'pointer', marginTop: '5px' }}>Remove</button>
            </div>
          ))}
          <button type="button" onClick={() => { const newItems = [...(en.items || []), { position: '', department: '', description: '' }]; updateField('en', 'items', newItems); }} style={{ background: '#4CAF50', color: 'white', padding: '8px 15px', border: 'none', borderRadius: '3px', cursor: 'pointer' }}>+ Add Opening</button>
        </div>
      )}

      {activeTab === 'cms-car-culture' && (
        <div>
          <div className="form-group"><label>Company Culture Overview</label><textarea value={en.overview || ''} onChange={(e) => updateField('en', 'overview', e.target.value)} rows="6" /></div>
          <div className="form-group"><label>Core Values</label><textarea value={(en.values || []).join('\n')} onChange={(e) => updateField('en', 'values', e.target.value.split('\n'))} rows="4" placeholder="One value per line" /></div>
          <div className="form-group"><label>Benefits</label><textarea value={(en.benefits || []).join('\n')} onChange={(e) => updateField('en', 'benefits', e.target.value.split('\n'))} rows="4" placeholder="One benefit per line" /></div>
        </div>
      )}

      <div className="btn-group">
        <button onClick={saveSection} disabled={!isDirty || isSaving} className="btn-primary">{isSaving ? 'Saving...' : 'Save'}</button>
      </div>
    </div>
  );
}
